export class PsOutsource {

    _id; // number
    _nif; // string
    _name; // string

    constructor(
        id,
        nif,
        name,
    ) {
        this._id = id;
        this._nif = nif;
        this._name = name;
    }

    static fromAPICompany(company) {
        return new this(
            company.id,
            company.nif || '',
            company.name || '',
        );
    }

    id() {
        return this._id;
    }

    nif() {
        return this._nif;
    }

    name() {
        return this._name;
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/document/shared/PsOutsource.js